/**
 * Content carousel, using Cycle 2
 */
$(function() {
    $('.page-content-2 .images, .page-content-4 .images').each(function() {
        var carousel = $(this);
        var pager;
        var prev;
        var next;

        if (carousel.find('> img').length < 2) {
            return;
        }

        // Create the carousel controls and add them to the carousel parent
        pager = $('<div class="pager"></div>');
        prev = $('<a href="#" class="prev">Previous</a>');
        next = $('<a href="#" class="next">Next</a>');

        carousel.after(pager, prev, next);

        // Make it go round
        carousel.cycle({
            slides: '> img',
            timeout: 0, // stop it going off on its own
            pager: pager,
            pagerActiveClass: 'active',
            pagerTemplate: '<a href="#">{{slideNum}}</a>',
            prev: prev,
            next: next,
            log: false
        });
    });
});
